import { createFileRoute } from '@tanstack/react-router';

import { useJobQueue } from '@/lib/api';

import BackgroundJobQueue from '@/components/job-queue';

export const Route = createFileRoute('/job-queue')({
    component: JobQueuePage,
});

function JobQueuePage() {
    const { data: jobQueue } = useJobQueue();

    return (
        <div className="flex-1" data-testid="JobQueue">
            {jobQueue && <BackgroundJobQueue stats={jobQueue} />}
        </div>
    );
}
